/**
 * Shared dependencies
 */
import type { StoreFunctions } from '../../shared/types/store';
import type { RecipeListItem } from '../../shared/types/lists';

/**
 * Internal dependencies
 */
import { getUserListItems } from '../requests';

/**
 * Fetches list items for a specific list and updates the store.
 * Also dispatches a ListEvent to notify other parts of the app.
 *
 * @param fn - Function to update the store state.
 * @param listId - The ID of the list to fetch items for.
 * @return Promise that resolves to an array of list items.
 */
export async function listsGetListItems(
	fn: StoreFunctions,
	listId: string
): Promise<RecipeListItem[]> {
	const items = await getUserListItems(listId);

	// Update the items for this specific list in the store
	fn.set((state) => {
		const list = state.data.lists[listId];
		if (!list) {
			return state;
		}

		return {
			data: {
				lists: {
					...state.data.lists,
					[listId]: {
						...list,
						items,
					},
				},
			},
		};
	});

	return items;
}
